export default "__VITE_ASSET__CEbAk8br__"